/**
 * @generated SignedSource<<9f92e23cc5ac6882f803dc9fc4833500>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateClinicianAvailabilityModal_query$data = {
  readonly " $fragmentSpreads": FragmentRefs<"ClinicianAvailabilityForm_query">;
  readonly " $fragmentType": "UpdateClinicianAvailabilityModal_query";
};
export type UpdateClinicianAvailabilityModal_query$key = {
  readonly " $data"?: UpdateClinicianAvailabilityModal_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateClinicianAvailabilityModal_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateClinicianAvailabilityModal_query",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ClinicianAvailabilityForm_query"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "a2f9d5afe6d154bf654a8b859ebecb83";

export default node;
